import { useCallback, useState } from 'react'
import { apiDelete } from '../client'
import { useSessionUser, useToken } from '@/store/authStore'
import { useMasterPasswordStore } from '@/store/masterPasswordStore'
import { useNoteKeyStore } from '@/store/noteKeyStore'
import { storeAccountRemovalNotice } from '@/utils/accountRemovalNotice'
import { clearNoteBodyCache } from '@/services/NoteBodyCache'
import { useNotesStore } from '@/store/notesStore'

interface RemoveAccountResponse {
    message: string
}

export function useRemoveAccount() {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)
    const { setToken } = useToken()

    const removeAccount = useCallback(async () => {
        if (loading) return

        setLoading(true)
        setError(null)

        try {
            const response = await apiDelete<RemoveAccountResponse>('/app/v1/account')

            storeAccountRemovalNotice(response.message)
            useMasterPasswordStore.getState().clearMasterKey()
            useNoteKeyStore.getState().clearAll()
            clearNoteBodyCache()
            useNotesStore.getState().setNotes([])
            setToken('')
            useSessionUser.getState().setUser({
                avatar: '',
                userName: '',
                email: '',
                authority: [],
            })
            useSessionUser.getState().setSessionSignedIn(false)

            window.location.assign('/login')
        } catch (caughtError: unknown) {
            const message = caughtError instanceof Error
                ? caughtError.message
                : 'Failed to remove account'

            setError(message)
            throw caughtError
        } finally {
            setLoading(false)
        }
    }, [loading, setToken])

    return { removeAccount, loading, error }
}
